import type { ChannelContent } from '@/alerts/treeTypes'

/**
 * A send node used to carry one common text beside its per-channel texts. The
 * node now holds only per-channel texts, so a loaded common text moves into the
 * empty body of each ticked channel and goes away. If a ticked channel has no
 * key it cannot hold a text, and the node stays as it is.
 */
export const foldCommonMessage = (
  data: Record<string, unknown>,
  channelIdsByKey: ReadonlyMap<string, number>
): Record<string, unknown> => {
  if (!('messageBody' in data)) return data
  const { messageBody, ...rest } = data
  const common = typeof messageBody === 'string' ? messageBody : ''
  if (common.trim() === '') return rest

  const keyById = new Map(
    [...channelIdsByKey].map(([key, id]) => [id, key] as const)
  )
  const ids = Array.isArray(data.channelIds) ? data.channelIds.map(Number) : []
  const keys = ids.map(id => keyById.get(id))
  if (keys.some(key => key === undefined)) return data

  const content: ChannelContent = { ...(data.channelContent as ChannelContent) }
  for (const key of keys as string[]) {
    const own = content[key]
    if (!own?.body?.trim()) content[key] = { ...own, body: common }
  }
  return { ...rest, channelContent: content }
}
